import React from 'react';
import { PageHero, SectionTitle, Card } from '../components/PageUI';

const FaqPage = () => {
  const categories = [
    {
      title: 'Sobre o Zartoo',
      items: ['O que está incluso na plataforma?', 'Como funciona a integração ERP + APP + PDV?', 'Qual o diferencial do BI integrado?']
    },
    {
      title: 'Implementação',
      items: ['Quanto tempo leva o onboarding?', 'Quais dados precisamos importar?', 'Como funciona o treinamento?']
    },
    {
      title: 'Suporte',
      items: ['Qual o SLA de atendimento?', 'Há suporte via WhatsApp?', 'Como abrir chamados?']
    },
    {
      title: 'Preços e contratação',
      items: ['Como é definido o investimento?', 'Existe contrato mínimo?', 'Quais formas de pagamento?']
    }
  ];

  return (
    <div>
      <PageHero
        eyebrow="FAQ"
        title="Respostas rápidas para suas dúvidas."
        subtitle="Tudo o que você precisa saber sobre Zartoo, implementação e suporte."
        primaryCta={{ label: 'Falar com especialista', href: '/especialista' }}
      />

      <section className="bg-slate-950">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Perguntas frequentes"
            title="Categorias em destaque"
            description="Selecione uma categoria e veja as principais respostas."
          />
          <div className="grid md:grid-cols-2 gap-6">
            {categories.map((category) => (
              <Card key={category.title}>
                <h3 className="text-xl font-semibold">{category.title}</h3>
                <div className="mt-4 space-y-3">
                  {category.items.map((question) => (
                    <details key={question} className="rounded-lg border border-white/10 bg-white/5 p-3">
                      <summary className="cursor-pointer font-semibold">{question}</summary>
                      <p className="text-sm text-slate-200/80 mt-2">
                        Fale com nosso time para obter detalhes e recomendações personalizadas.
                      </p>
                    </details>
                  ))}
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FaqPage;
